import React from "react";

const Avatar = (props) => {
  const { img, alt, name } = props;
  return (
    <div className="avatar">
      <div className="profile">
        <div className="img">
          <img src={img} alt={alt} />
        </div>
        <h3>{name}</h3>
      </div>
      <div className="view-all">
        <p>View All</p>
        <i className="fas fa-chevron-right"></i>
      </div>
    </div>
  );
};

export default Avatar;
